import React, { useEffect, useState } from "react";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete";
import { Input } from "antd";
const LocationSearch = ({
  name,
  placeholder,
  value,
  onChange,
  setLocationInfo,
}) => {
  const [initialValue, setInitialValue] = useState(value);
  const handleChange = (address) => {
    setInitialValue(address);
    const e = {
      target: {
        name,
        value: address,
      },
    };
    onChange(e);
    if (address.length <= 0) {
      setLocationInfo({});
    }
  };
  const findCityAndCountry = (data) => {
    let city = "";
    let country = "";
    data.forEach((element) => {
      if (element.types[0] === "country") {
        country = element.long_name;
      }
      if (element.types[0] === "administrative_area_level_2") {
        city = element.long_name;
      }
    });
    return { city, country };
  };
  const handleSelect = (address) => {
    geocodeByAddress(address)
      .then(async (results) => {
        const data = results[0].address_components;
        const formatedAddress = results[0].formatted_address;
        const e = {
          target: {
            name,
            value: formatedAddress,
          },
        };
        onChange(e);
        setInitialValue(formatedAddress);
        const latLong = await getLatLng(results[0]);
        const { city, country } = findCityAndCountry(data);
        setLocationInfo({ latLong, city, country });
      })
      .catch((error) => console.error("Error", error));
  };
  useEffect(() => {
    if (value?.length <= 0) {
      setInitialValue("");
    } else setInitialValue(value);
  }, [value, setInitialValue]);
  return (
    <PlacesAutocomplete
      value={initialValue}
      onChange={handleChange}
      onSelect={handleSelect}
    >
      {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
        <div>
          <Input.TextArea
            {...getInputProps({
              placeholder,
            })}
            size="large"
            autoSize={{ minRows: 3 }}
            maxLength={250}
            style={{ borderRadius: 8 }}
          />
          <div className="autocomplete-dropdown-container">
            {loading && <div>Loading...</div>}
            {suggestions.map((suggestion, index) => {
              const className = suggestion.active
                ? "suggestion-item--active"
                : "suggestion-item";
              // inline style for demonstration purpose
              const style = suggestion.active
                ? {
                    backgroundColor: "#fafafa",
                    cursor: "pointer",
                    fontWeight: "bold",
                    margin: ".5rem 0",
                  }
                : {
                    backgroundColor: "#ffffff",
                    cursor: "pointer",
                    margin: ".5rem 0",
                  };
              return (
                <div
                  key={index}
                  style={{ margin: "1rem", backgroundColor: "red" }}
                  {...getSuggestionItemProps(suggestion, {
                    className,
                    style,
                  })}
                >
                  <span>{suggestion.description}</span>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </PlacesAutocomplete>
  );
};

export { LocationSearch as default };
